import { useState, useEffect, forwardRef, useRef } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Reusabletable from '../../../register/FormInputs/reusableforms/Reusabletable'
import {
  createStates,
  getStates,
  updateStatesById,
  deleteStatesById,
} from "./../../../../services/global_redux/globale_actions/States.action";
import "./States.css";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import $ from "jquery";
import { getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import mainicon from "../../../../assets/global_assets/holiday_table/table_main_icon.png"


const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function States({ showSnackbar, setLoading }) {
  const [activeForm, setActiveForm] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [data, setData] = useState([]);
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [openeditalert, setOpeneditalert] = useState(false);
  const [opendeletealert, setopendeletealert] = useState(false);
  const [deleteclientid, setdeleteclientid] = useState(null);
  const [openaddsingle, setOpenaddsingle] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [order, setorder] = useState("ASC");
  const initialStateInput = {
    state_name: "",
    state_code: "",
  };
  const [formData, setFormData] = useState(initialStateInput);
  const { loading, message, error } = useSelector((state) => state.states);
  const [checkCreate, setCheckCreate] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkDelete, setCheckDelete] = useState(false);
  const [actionChecked, setActionChecked] = useState("");
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };


  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...data].sort((a, b) =>
        typeof a[col] === "number" && typeof b[col] === "number"
          ? a[col] - b[col]
          : a[col].toLowerCase() > b[col].toLowerCase()
            ? 1
            : -1
      );
      setData(sorted);
      setorder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...data].sort((a, b) =>
        typeof a[col] === "number" && typeof b[col] === "number"
          ? b[col] - a[col]
          : a[col].toLowerCase() < b[col].toLowerCase()
            ? 1
            : -1
      );
      setData(sorted);
      setorder("ASC");
    }
  };

  const headers = [
    { label: "State Name", key: "state_name" },
    { label: "State Code", key: "state_code" },
  ];

  const header = [
    { key: "state_name", value: "State Name", input: "text" },
    { key: "state_code", value: "State Code", input: "text" },
  ];
  useEffect(() => {
    if (data) {
      var allChecked = data.every((item) => item.checked);
    }
    setSelectAll(allChecked);
  }, [data]);

  const handleCheckboxChange = (id) => {
    const newData = data.map((item) => {
      if (item.id === id) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setData(newData);
    setCheckedItemCount(getCheckedItemCount(newData));
  };
  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    const newData = data.map((item) => ({ ...item, checked: newSelectAll }));
    setData(newData);
    setSelectAll(newSelectAll);
    setCheckedItemCount(getCheckedItemCount(newData));
  };
  const getCheckedItemCount = (data) => {
    return data.filter((item) => item.checked).length;
  };

  const addsinglehandleClose = () => {
    setOpenaddsingle(false);
    setIsFormOpen(false);
    setActiveForm(null);
  };
  const edithandleClickOpenalert = () => {
    setOpeneditalert(true);
  };

  const handleCloseeditalert = () => {
    setOpeneditalert(false);
  };
//   const handledeleteClickOpenalert = (id) => {
//     setopendeletealert(true);
//     setdeleteclientid(id);
//     handleDeleteClick();
//   };
const handledeleteClickOpenalert = async (id) => {
    setLoading(true);
    setopendeletealert(false);
    try {
      const response = await dispatch(deleteStatesById(id));
      if (response.success) {
        showSnackbar(response.message, "success");
        setLoading(false);
        setOpeneditalert(false);
        handleFetchStates();

        setOpeneditalert(false);
        setActionChecked("delete");
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };

  const handledeleteClosealert = () => {
    setopendeletealert(false);
  };

  const dispatch = useDispatch();

  const handleFetchStates = async () => {
    try {
      const response = await dispatch(getStates());
      setData(response.data.states);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    handleFetchStates();
  }, [dispatch]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    handleAddState(formData);
  };
  const handleAddState = async (StateDataInput) => {
    const result = await dispatch(createStates(StateDataInput));
    if (result.success) {
      setLoading(false);
      showSnackbar("State added successfully ", "success");
      addsinglehandleClose();
      setFormData(initialStateInput);
      handleFetchStates();
      setActionChecked("create");
    } else {
      setLoading(false);
      showSnackbar(`Failed to add state: ${result.message}`, "error");
    }
  };

  const handleFormToggle = (form) => {
    setIsFormOpen(true);
  };
  const handleFormToggleSingleDataEntry = (form) => {
    setActiveForm(form);
    if (form == "AddState") {
      addsinglehandleClickOpen();
    }
    setIsFormOpen(true);
  };


  const handleIconClick = () => {
    setIsFormOpen(false);
    setActiveForm(null);
  };
  const handleSearchClick = (e) => {
    e.preventDefault();
    const value = $("#searchInput").val().toLowerCase();
    $("#dataTable tbody tr").each(function () {
      const rowText = $(this).text().toLowerCase();
      const isVisible = rowText.includes(value);
      $(this).toggle(isVisible);
    });
  };
  const addsinglehandleClickOpen = () => {
    setOpenaddsingle(true);
  };

  const handleEditClick = (id) => {
    const item = data.find((d) => d.id === id);
    console.log("item", item);
    setEditableRow(id);
    setEditedValues({ ...item });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedValues({
      ...editedValues,
      [name]: value,
    });
  };

  const handleSaveClick = async (e) => {
    setOpeneditalert(false);
    setLoading(true);
    try {
      const response = await dispatch(
        updateStatesById(editedValues.id, editedValues)
      );
      if (response.message) {
        showSnackbar(response.message, "success");
        setLoading(false);
        handleFetchStates();
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };

  const handleCancelClick = () => {
    setEditableRow(null);
    setEditedValues({});
  };

  const handleDeleteClick = async () => {
    setLoading(true);
    setopendeletealert(false);
    try {
      const response = await dispatch(deleteStatesById(deleteclientid));
      if (response.success) {
        showSnackbar(response.message, "success");
        setLoading(false);
        setOpeneditalert(false);
        handleFetchStates();
        setActionChecked("delete");

        setOpeneditalert(false);
      } else {
        showSnackbar(response.message, "warning");
        setLoading(false);
      }
    } catch (error) {
      showSnackbar("An error occurred", "error");
      setLoading(false);
    }
    setEditableRow(null);
  };
  const files = () => { handleFormToggleSingleDataEntry("AddState")};

  const getUserPermission = async () => {
    try {
        const response = await dispatch(getUserRole());
            const rawPermissions = response?.data?.permissions;
            const parsedPermissions = typeof rawPermissions === "string"
                ? JSON.parse(rawPermissions)
                : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                ? JSON.parse(rawPermissions[0])
                : rawPermissions;
            parsedPermissions.forEach((item) => {
              if (item.section == "Configuration" && item.module == "States") {
                          setCheckCreate(item.action.create);
                          setCheckEdit(item.action.edit);
                          setCheckDelete(item.action.delete);
              }})

    } catch (err) {
      console.error("Failed to fetch states:", err);
    }

};
useEffect(() => {
  getUserPermission();
}, [dispatch]);
  return (
    <div className="container-fluid">
      
        <Dialog
            open={openaddsingle}
            onClose={addsinglehandleClose}
            TransitionComponent={Transition}
        >
            <AppBar
            className="state-add-single-header"
            sx={{ position: "relative" }}
            >
            <Toolbar>
                <Typography
                sx={{ ml: 1, flex: 1 }}
                variant="h6"
                component="div"
                >
                Add state
                </Typography>
                <IconButton
                edge="end"
                color="inherit float-end"
                onClick={addsinglehandleClose}
                aria-label="close"
                >
                <CloseIcon className="text-white" />
                </IconButton>
            </Toolbar>
            </AppBar>
            <List>
            <div className="card mx-2">
                <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="col-md-12">
                    <div className="row">
                        {Object.keys(formData).map((key) => (
                        <div className="col-md-6 mb-3" key={key}>
                            <label htmlFor={key}>
                            <b>
                                {key
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                                <span className="text-danger">*</span>
                            </b>
                            </label>
                            <input
                            type="text"
                            className="form-control mt-1"
                            id={key}
                            placeholder=""
                            value={formData[key]}
                            onChange={handleChange}
                            required
                            />
                        </div>
                        ))}
                    </div>
                    </div>
                    <div className="col-md-12 pe-3">
                    <div className="row float-end">
                        <button
                        className="btn btn-md btn-success me-3"
                        type="submit"
                        >
                        <b>Submit</b>
                        </button>
                    </div>
                    </div>
                </form>
                </div>
            </div>
            </List>
        </Dialog>
        {/* <Reusabletable
            data={data}
            header={header}
            setFile={"single_input"}
            handleFileUpload={null}
            submitdelete={null}
            handleSaveClick={handleSaveClick}
            setEditableRow={setEditableRow}
            editableRow={editableRow}
            setEditedValues={setEditedValues}
            editedValues={editedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            title={'States'}
            setLoading={setLoading}
            filestemp= {files}
            showSnackbar={showSnackbar}
            getCreatePermission = {checkCreate}
            getEditPermission = {checkEdit}
            getDeletePermission = {checkDelete}
        /> */}
            {/* <ImportFileform
                setFile={setFile}
                title={'States'}
                filestemp={files}
                handleFileUpload={handleFileUpload}

            /> */}
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'States'}
            data={data}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {true}
            getDeletePermission = {true}
            // date={date}
            submitdelete={null}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}
            createOrfilterComp={
                <></>
            }
            />
    </div>
  );
}

export default States;
